import React from "react";

export default function Select<T extends string>({
  value,
  onChange,
  options,
  placeholder = "— Select —",
  required,
  className = "",
  disabled = false,
}: {
  value?: T | "";
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: T[];
  placeholder?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
}) {
  return (
    <select
      value={value ?? ""}
      onChange={onChange}
      required={required}
      disabled={disabled}
      className={`w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none
                 text-gray-900 focus:border-sky-500 focus:ring-2 focus:ring-sky-500/20 disabled:bg-gray-100 disabled:text-gray-400 ${className}`}
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {options.map((o) => (
        <option key={o} value={o}>
          {o}
        </option>
      ))}
    </select>
  );
}
